type DragData = {
  category: string;
  propertyName: string;
  displayName: string;
};

export const PROPERTY_DRAG_DATA_FORMAT = 'application/x-sparkel-property-info';

export function formatDragData({
  category,
  propertyName,
  displayName,
}: DragData) {
  return `${category}🦄${propertyName}🦄${displayName}`;
}

export function parseDragData(data: string): DragData | null {
  const dataParts = data.split('🦄');
  if (dataParts.length !== 3) {
    return null;
  } else {
    const [category, propertyName, displayName] = dataParts;
    return { category, propertyName, displayName };
  }
}
